export enum BillingChargeSubtype {
  ReturnCoverage = "ReturnCoverage",
  PackageProtectionPlus = "PackageProtectionPlus",
  FinalSaleReturnCoverage = "FinalSaleReturnCoverage",
  ExtendedWarranty = "ExtendedWarranty",
  UpsellRevenue = "UpsellRevenue",
  UpsellRevenueRefunded = "UpsellRevenueRefunded",
  ManagedClaimCredit = "ManagedClaimCredit",
  RedoManagedReturnsCoverage = "RedoManagedReturnsCoverage",
  InstantExchangeRecovery = "InstantExchangeRecovery",
  InstantRefund = "InstantRefund",
  RepairFeeCredit = "RepairFeeCredit",
  CoverageRefundForCancelledOrder = "CoverageRefundForCancelledOrder",
  CancelledOrderPackageProtectionPlusRefund = "CancelledOrderPackageProtectionPlusRefund",
  DeniedClaimPackageProtectionPlusRefund = "DeniedClaimPackageProtectionPlusRefund",
  CancelledOrderFinalSaleReturnCoverageRefund = "CancelledOrderFinalSaleReturnCoverageRefund",
  CancelledOrderExtendedWarrantyRefund = "CancelledOrderExtendedWarrantyRefund",
  CancelledOrderRmrProcessingCoverageShareRefund = "CancelledOrderRmrProcessingCoverageShareRefund",
  CancelledOrderRmrConsolidationCoverageShareRefund = "CancelledOrderRmrConsolidationCoverageShareRefund",
  CancelledOrderInstantExchangeRecovery = "CancelledOrderInstantExchangeRecovery",
  FinalSaleCredit = "FinalSaleCredit",
  CarrierClaimRefund = "CarrierClaimRefund",
  ClaimPayout = "ClaimPayout",
  ClaimCommission = "ClaimCommission",
  ExchangeShippingCredit = "ExchangeShippingCredit",
  PerOrder = "PerOrder",
  PerSms = "PerSms",
  PerEmail = "PerEmail",
  OrderTracking = "OrderTracking",
  MerchantCoveredLabel = "MerchantCoveredLabel",
  Damaged = "Damaged",
  WrongProduct = "WrongProduct",
  MerchantCarrierLabelCredit = "MerchantCarrierLabelCredit",
  ShippingCostShare = "ShippingCostShare",
  ReturnLabelMarkupRevenue = "ReturnLabelMarkupRevenue",
  CustomerPaidLabel = "CustomerPaidLabel",
  PerReturnFee = "PerReturnFee",
  ReturnsProcessingFee = "ReturnsProcessingFee",
  ReturnFraudPrevention = "ReturnFraudPrevention",
  PointOfSale = "PointOfSale",
  PerRecycleRequestFee = "PerRecycleRequestFee",
  ReFulfillmentRevenueShare = "ReFulfillmentRevenueShare",
  ReFulfillmentShippingAdjustment = "ReFulfillmentShippingAdjustment",
  PerExchangePayoutFee = "PerExchangePayoutFee",
  MerchantCreatedReturnLabel = "MerchantCreatedReturnLabel",
  PackagePickup = "PackagePickup",
  CanceledReturnLabelRefund = "CanceledReturnLabelRefund",
  CanceledPickupRefund = "CanceledPickupRefund",
  OutboundLabel = "OutboundLabel",
  ReturnLabelAdjustment = "ReturnLabelAdjustment",
  ImplementationFee = "ImplementationFee",
  CardProcessingFee = "CardProcessingFee",
  ManualAdjustment = "ManualAdjustment",
  ManualRefund = "ManualRefund",
  FreeTrialCredit = "FreeTrialCredit",
  VoidLabel = "VoidLabel",
  VoidUsedLabel = "VoidUsedLabel",
  ChargeLabel = "ChargeLabel",
  CarrierPickup = "CarrierPickup",
  Refund = "Refund",
  Miscellaneous = "Miscellaneous",
  Surcharge = "Surcharge",
  ReturnLabel = "ReturnLabel",
  MerchantCarrierFee = "MerchantCarrierFee",
  SubscriptionFee = "SubscriptionFee",
  RedeemPoints = "RedeemPoints",
  Insurance = "Insurance",
  VoidInsurance = "VoidInsurance",
  TransactionFailureClawback = "TransactionFailureClawback",
  WmsFee = "WmsFee",
  RedoSupply = "RedoSupply",
  LandedCostDuties = "LandedCostDuties",
  LandedCostTaxes = "LandedCostTaxes",
  LandedCostFees = "LandedCostFees",
  VoidLandedCostDuties = "VoidLandedCostDuties",
  VoidLandedCostTaxes = "VoidLandedCostTaxes",
  VoidLandedCostFees = "VoidLandedCostFees",
  FreightPurchase = "FreightPurchase",
  VoidFreightPurchase = "VoidFreightPurchase",
  CancelledExtendedWarrantyRefund = "CancelledExtendedWarrantyRefund",
  CancelledPackageProtectionPlusRefund = "CancelledPackageProtectionPlusRefund",
  CancelledFinalSaleReturnCoverageRefund = "CancelledFinalSaleReturnCoverageRefund",
  CancelledInstantExchangeRecovery = "CancelledInstantExchangeRecovery",
  MerchantPaidPpPlusPerOrder = "MerchantPaidPpPlusPerOrder",
  ConsolidationShipping = "ConsolidationShipping",
  RmrProcessingCoverageShare = "RmrProcessingCoverageShare",
  RmrConsolidationCoverageShare = "RmrConsolidationCoverageShare",
  RevShareCoverage = "RevShareCoverage",
  FinalSaleRevShareCoverage = "FinalSaleRevShareCoverage",
  FinalSaleCreditAdjustment = "FinalSaleCreditAdjustment",
  CoverageAdjustment = "CoverageAdjustment",
  NonCoverageAdjustment = "NonCoverageAdjustment",
  PpPlusAdjustment = "PpPlusAdjustment",
  FsrAdjustment = "FsrAdjustment",
  RmrAdjustment = "RmrAdjustment",
  OmsAdjustment = "OmsAdjustment",
  OtherAdjustment = "OtherAdjustment",
  ClaimsAdjustment = "ClaimsAdjustment",
  MerchantIncentive = "MerchantIncentive",
  ZeroOutAccountBalance = "ZeroOutAccountBalance",
  ChopAdjustment = "ChopAdjustment",
  OrderTrackingAdjustment = "OrderTrackingAdjustment",
  ShopperAiAdjustment = "ShopperAiAdjustment",
  SubscriptionAdjustment = "SubscriptionAdjustment",
  WarrantiesAdjustment = "WarrantiesAdjustment",
  MarketingAdjustment = "MarketingAdjustment",
  DutyDrawbackCredit = "DutyDrawbackCredit",
  ReduceBalance = "ReduceBalance",
  PromotionalCredit = "PromotionalCredit",
  UspsPcPostageFee = "UspsPcPostageFee",
  Writeoff = "Writeoff",
  PersonalizedInsertFee = "PersonalizedInsertFee",
  PersonalizedInsertRevenueShare = "PersonalizedInsertRevenueShare",
}

export enum BillingPeriod {
  Monthly = "Monthly",
  Yearly = "Yearly",
  Bimonthly = "Bimonthly",
  Weekly = "Weekly",
}

export enum CampaignChannel {
  Sms = "Sms",
  Mms = "Mms",
  Email = "Email",
}

export enum SubscriptionProduct {
  MarketingSms = "MarketingSms",
  MarketingEmail = "MarketingEmail",
  OrderTracking = "OrderTracking",
  ReturnAiExchange = "ReturnAiExchange",
  Returns = "Returns",
  CheckoutOptimization = "CheckoutOptimization",
  Aeo = "Aeo",
  Ims = "Ims",
  ImsForecasting = "ImsForecasting",
  Recover = "Recover",
  SupportBase = "SupportBase",
  SupportAi = "SupportAi",
  SupportSms = "SupportSms",
  SupportVoice = "SupportVoice",
  Oms = "Oms",
  Wms = "Wms",
  Disputes = "Disputes",
  Lcg = "Lcg",
  Ctx = "Ctx",
}

export enum BillingAutomation {
  Auto = "Auto",
  Manual = "Manual",
}

export enum BillingFailureMode {
  Allow = "Allow",
  Restrict = "Restrict",
}
